import { render } from "./DonationForm.vue?vue&type=template&id=6de89d7c&ts=true"
import script from "./DonationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationForm.vue?vue&type=script&setup=true&lang=ts"

import "./DonationForm.vue?vue&type=style&index=0&id=6de89d7c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/DonationForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6de89d7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6de89d7c', __exports__)) {
    api.reload('6de89d7c', __exports__)
  }
  
  module.hot.accept("./DonationForm.vue?vue&type=template&id=6de89d7c&ts=true", () => {
    api.rerender('6de89d7c', render)
  })

}


export default __exports__